import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--delete-confirmation"
export default class extends Controller {
  static targets = ["modal", "input", "submitButton"]
  static values = {
    confirmWord: { type: String, default: "delete" }
  }

  connect() {
    this.resetState()
  }

  open(event) {
    event.preventDefault()
    if (!this.hasModalTarget) return

    this.resetState()
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.inputTarget.focus()
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.resetState()
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    if (this.modalOpen()) this.close()
  }

  swallowEvent(event) {
    event.stopPropagation()
  }

  validateInput() {
    if (!this.hasSubmitButtonTarget) return

    const typedValue = this.inputTarget.value.trim().toLowerCase()
    const expectedValue = this.confirmWordValue.toLowerCase()
    this.submitButtonTarget.disabled = typedValue !== expectedValue
  }

  modalOpen() {
    return this.hasModalTarget && !this.modalTarget.classList.contains("hidden")
  }

  resetState() {
    if (this.hasInputTarget) this.inputTarget.value = ""
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true
  }
}
